import styled from 'styled-components';

export const StyledDropzoneModalBody = styled.div`
  .modalHead {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .modalBody {
    display: flex;
    flex-direction: column;
    gap: 20px;
    font-size: 16px;
  }

  .modalButtons {
    display: flex;
    justify-content: flex-end;
  }
`;
